var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChristmasSock = function SvgChristmasSock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true",
    vectorEffect: "non-scaling-stroke",
    viewBox: "-0.75 -0.75 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M7.492 6.281a.917.917 0 0 0-.54 1.219l1.935 4.615h0a1.375 1.375 0 0 1-.807 1.77h0l-2.148.804a3.67 3.67 0 0 0-2.15 4.721h0a3.67 3.67 0 0 0 4.721 2.152l8.156-3.052h0a3.21 3.21 0 0 0 1.882-4.13h0l-1.601-3.355-2.26-6.31a.92.92 0 0 0-1.17-.555z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M8.018 21.708a4.24 4.24 0 0 0 .918-4.224 4.07 4.07 0 0 0-3.264-2.683m12.052-2.136a4.9 4.9 0 0 0-1.7.21 4.125 4.125 0 0 0-2.419 5.313 4.1 4.1 0 0 0 .718 1.2m-.228-15.234V.704"
  })));
};
export default SvgChristmasSock;